import { FormProvider } from "react-hook-form";
import { cn } from "@/app/utils/cn";
import CreditBalanceForm from "./components/CreditBalanceForm";
import { useSelfHiringContext } from "@/app/contexts/SelfHiringContext";
import { Steps } from "./components/Steps";
import { useCreditController } from "./useCreditController";
import { PartnerSimulation } from "./components/partnerSimulation";
import { FinalizationForm } from "./components/FinalizationForm";
import { Formalization } from "./components/Formalization";

export default function Credit() {
  const companyName = import.meta.env.VITE_COMPANY;

  const { methods, partners, hasCrefaz } = useCreditController();

  const { step, nextStep } = useSelfHiringContext();

  const steps = {
    1: {
      title: `Faça uma simulação de Empréstimo com a <span class="text-primary">${companyName}</span>`,
      component: <CreditBalanceForm onNext={nextStep} hasCrefaz={hasCrefaz} />,
    },
    2: {
      title: `Empréstimo na palma da mão com a <span class="text-primary">${companyName}</span>`,
      component: (
        <PartnerSimulation partners={partners || []} onNext={nextStep} />
      ),
    },
    3: {
      title:
        'Facilitamos o processo para o seu <span class="text-primary">agrado</span>',
      component: <FinalizationForm />,
    },
    4: {
      title: "Proposta Concluída",
      component: <Formalization />,
    },
  };

  return (
    <>
      <FormProvider {...methods}>
        <form
          className="w-full"
          onSubmit={methods.handleSubmit((data) =>
            console.log(data, "submitt"),
          )}
        >
          <div className="my-4 px-4 flex flex-col items-center justify-center gap-5 pt-4 w-full max-w-7xl mx-auto">
            <h1
              dangerouslySetInnerHTML={{
                __html: steps[step as keyof typeof steps]?.title || "",
              }}
              className="mx-auto max-w-[400px] text-center text-lg font-bold md:text-2xl"
            />
            <Steps />

            <div className={cn("w-full", step !== 2 && "max-w-lg mx-auto")}>
              {steps[step as keyof typeof steps]?.component}
            </div>
          </div>
        </form>
      </FormProvider>
    </>
  );
}
